export const PAYMENT_TYPES = {
  CASH: 'cash',
  QUOTES: 'quotes'
};
